import {SystemPopupsManager, SystemPopupsManagerEvents, SystemPopupsView} from './index';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

export class SystemPopupsModuleBasicState extends ModuleState<SystemPopupsView, SystemPopupsManager, SystemPopupsManagerEvents> {
    public onEnterState(): void {

    }

    public onLeaveState(): void {

    }

    protected setupEvents(): void {
        this.setEventHandler('General.Popups.Add', this.onAddedPopup.bind(this));
    }

    protected onAddedPopup(): void {
        if (this.module.hasPopups()) {
            this.module.gotoState(SystemPopupsManager.SHOWING_STATE);
        }
    }
}
